import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellOrderStatusBar, { SellOrderStatusBarNew, SellOrderStatusBarProps } from '../../../SellOrderStatusBar'
import SellOrderCreateStepButtons, { SellOrderCreateStepButtonsNew } from '../SellOrderCreateStepButtons'

type SellOrderCreateStepHeaderProps = & SellOrderStatusBarProps & OrderStepButtonsBaseComponentProps

const SellOrderCreateStepHeaderDecider: React.FC<SellOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellOrderCreateStepHeaderDefault} NewComponent={SellOrderCreateStepHeaderNew} {...rest} />
    )
}

const SellOrderCreateStepHeaderDefault: React.FC<SellOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellOrderStatusBar {...rest} />
            <SellOrderCreateStepButtons {...rest} />
        </div>
    )
}

const SellOrderCreateStepHeaderNew: React.FC<SellOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellOrderStatusBarNew {...rest} />
            <SellOrderCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellOrderCreateStepHeaderDecider